import {createStore} from 'redux';
import data from './.data';
import {saveToLocal, getFromLocal} from './LocalActionUtils/addCart';

let stateChanger = (state, action) => {
  if(state === undefined) {
    let cart = getFromLocal('cart');
    cart = cart ? cart : [];
    return Object.assign({}, data, {
      cart
    })
  }else {
    if (action.type === 'GET_MENU') {
      return Object.assign({}, state, {
        menu: action.payload
      })
    }else if(action.type === 'THUMBS_UP'){
      let {data, num} = action.payload;
      let newState = JSON.parse(JSON.stringify(state))
      newState.menu.forEach((i)=> {
        if(i._id == data.menu_id) {
          i.content.forEach((j)=> {
            if(j._id == data.id) {
              j.thumbsUp = j.thumbsUp !== undefined ? j.thumbsUp + 1 : 1;
              return
            }
          })
        };
      })
      return Object.assign({}, state, {
        ...newState
      })
    }else if(action.type === "ADD_CART"){
      // initialize / inherit the cart;
      let cart = state.cart ? state.cart : [];
      // decide whether there the item is already in the cart - put in / add num
      let id = action.payload._id;
      let exist = cart.find((i)=> {
        if(i.id === id) i.num += 1;
        return i.id === id;
      });
      exist ? null : cart.push({info:action.payload, num: 1, id: action.payload._id});
      cart = JSON.parse(JSON.stringify(cart));

      /* save cart data to local*/
      saveToLocal('cart', cart);
      return Object.assign({}, state, {
        cart
      })
    }else {
      return state
    }
  }
}

const store = createStore(stateChanger)


export default store;